// extracted by mini-css-extract-plugin
export default {"services":"OurServices_services__H2mvG","list":"OurServices_list__XV+IY","item":"OurServices_item__crGDI","title":"OurServices_title__pWd9M","text":"OurServices_text__UBYbz"};